import { useEffect, useState } from 'react';

/**
 * `value`, held back until it has stopped changing for `delay` ms.
 *
 * The search inputs need this because the query moved to the server. A
 * dispatcher typing "Statybų" is eight keystrokes, and without a debounce
 * that is eight round trips — seven of which are already stale before they
 * land, and all eight of which run a LIKE scan on the server. 300ms is the
 * usual sweet spot: below a typist's inter-key gap, above the point where
 * the result feels like it lags the typing.
 *
 * The cleanup is the part that matters. Clearing the previous timer on every
 * change is what makes this a debounce rather than a queue of eight delayed
 * updates that all fire 300ms apart.
 */
export function useDebouncedValue(value, delay = 300) {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return settled;
}
